/**
 * The designer's control styling, shared with the lazily-loaded body editor.
 *
 * Split out for the same reason as `types.ts`: the body editor sits behind a
 * dynamic import and must not reach back into the module that imports it.
 */

export const inputStyle: React.CSSProperties = {
  height: 30, padding: '0 8px', borderRadius: 6, fontSize: '0.9025rem',
  border: '1px solid var(--color-border)', background: 'var(--color-bg)',
  color: 'var(--color-text)', width: '100%', boxSizing: 'border-box',
}

export function buttonStyle(primary: boolean): React.CSSProperties {
  return {
    height: 28, padding: '0 12px', borderRadius: 6, fontSize: '0.8425rem',
    cursor: 'pointer',
    border: `1px solid ${primary ? 'var(--color-accent)' : 'var(--color-border)'}`,
    background: primary ? 'var(--color-accent)' : 'var(--color-bg)',
    color: primary ? '#fff' : 'var(--color-text)',
  }
}
